import { FC, useState } from 'react';
import About from './components/About';
import AboutTwo from './components/AboutTwo';
import AboutThree from './components/AboutThree';

type IProductProps = object;

const Product: FC<IProductProps> = () => {
  return (
    <div className='mt-10'>
      <About />
    </div>
  );
};

export default Product;
